export default "__VITE_ASSET__5d649d35__"